(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chillnet-cart-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chillnet-tee-card')) {
    customElements.define('chillnet-tee-card', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('select').addEventListener('change', (event) => {
          event.stopPropagation();
          this.querySelector('[data-tee-price]').textContent = event.target.selectedOptions[0].dataset.price;
          this.querySelector('[type="submit"]').disabled = !event.target.value;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
